<template>
  <form class="ui form settings plan-page" @submit.prevent="continueToPayment">
    <div class="ui grid onboarding-h1-row">
      <div class="sixteen wide column">
        <h1>
          Select a plan to start your <strong>FREE 14-day trial</strong>
        </h1>
      </div>
    </div>

    <div class="ui stackable grid onboarding-content-row">
      <div class="sixteen wide mobile eight wide computer column">
        <p class="body-large plan-page__heading">All plans unlock:</p>
        <ul class="plan-page__features">
          <li><img src="../../assets/img/icn_success_outline.svg" alt="" class="plan-page__check-icon" aria-hidden="true"> Send unlimited quote &amp; invoices</li>
          <li><img src="../../assets/img/icn_success_outline.svg" alt="" class="plan-page__check-icon" aria-hidden="true"> Add unlimited employees</li>
          <li><img src="../../assets/img/icn_success_outline.svg" alt="" class="plan-page__check-icon" aria-hidden="true"> Smardie branding removed</li>
          <li><img src="../../assets/img/icn_success_outline.svg" alt="" class="plan-page__check-icon" aria-hidden="true"> Priority support</li>
        </ul>
      </div>
      <div class="sixteen wide mobile eight wide computer column">
        <PlanFrequencySelect
          :model-value="interval"
          :options="frequencyOptions"
          @update:model-value="interval = $event"
        />
        <p class="plan-page__disclaimer">
          <img src="../../assets/img/icn_info.svg" alt="" class="plan-page__disclaimer-icon" aria-hidden="true">
          Your card won't be charged until day 14.
        </p>
      </div>
    </div>

    <div class="ui divider onboarding-divider"></div>

    <div class="onboarding-actions">
      <button type="button" class="onboarding-back-btn ui basic button" @click="$router.push('/onboarding/job-settings')">Back</button>
      <button
        type="submit"
        class="onboarding-continue-btn ui primary button settings-save-btn"
      >
        Continue
      </button>
    </div>
  </form>
</template>

<script>
import PlanFrequencySelect from '@/components/common/PlanFrequencySelect.vue';

export default {
  name: 'OnboardingPlan',
  components: { PlanFrequencySelect },
  data() {
    return {
      interval: 'yearly',
      frequencyOptions: [
        {
          value: 'yearly',
          label: 'Yearly',
          mostPopular: true,
          originalPrice: '$1020.00',
          price: '$820.00 /year',
          priceSub: '$68.30 /month'
        },
        {
          value: 'monthly',
          label: 'Monthly',
          mostPopular: false,
          price: '$85.00 /month'
        }
      ]
    };
  },
  methods: {
    continueToPayment() {
      this.$router.push({ path: '/onboarding/payment', query: { interval: this.interval } });
    }
  }
};
</script>

<style scoped>
.plan-page {
  padding-bottom: 1rem;
}
.onboarding-h1-row {
  margin-bottom: 0;
}
.onboarding-content-row {
  margin-top: 1rem;
}
.plan-page__heading {
  margin-bottom: 0.75rem;
  font-weight: 600;
}
.plan-page__features {
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 1.125rem;
  line-height: 1.5;
  color: var(--color-text);
}
.plan-page__features li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}
.plan-page__check-icon {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  display: block;
}
.plan-page__disclaimer {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
  font-size: 0.9375rem;
  color: var(--color-text-muted);
}
.plan-page__disclaimer-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: block;
}
.onboarding-divider {
  margin: 2rem 0 0 0;
  border-top: 1px solid var(--color-border-subtle);
}
.onboarding-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  padding-top: 0;
}
.onboarding-actions .onboarding-back-btn,
.onboarding-actions .onboarding-continue-btn {
  height: 36px;
  line-height: 36px;
  padding-top: 0;
  padding-bottom: 0;
}
@media (max-width: 767px) {
  .onboarding-actions {
    flex-direction: column;
    gap: 16px;
  }
  .onboarding-actions .onboarding-continue-btn,
  .onboarding-actions .onboarding-back-btn {
    width: 100%;
  }
  .onboarding-actions .onboarding-continue-btn {
    order: 1;
    margin-bottom: 0 !important;
  }
  .onboarding-actions .onboarding-back-btn {
    order: 2;
  }
}
</style>
